import chromeAddOnError from "./chrome-add-on-error";
import chromeMobileFillrError from "./chrome-mobile-fillr-error";
import edgeAutofillError from "./edge-autofill-error";
import firefoxMetadataError from "./firefox-metadata-error";
import googleTagError from "./google-tag-error";
import gsaTypeError from "./gsa-type-error";
import mobileFirefoxError from "./mobile-firefox-error";
import referenceError from "./reference-error";
import unexpectedNumberError from "./unexpected-number-error";
import xhrNetworkError from "./xhr-network-error";

export const errorHandlers = [
  chromeAddOnError,
  chromeMobileFillrError,
  edgeAutofillError,
  firefoxMetadataError,
  googleTagError,
  gsaTypeError,
  mobileFirefoxError,
  referenceError,
  unexpectedNumberError,
  xhrNetworkError
];

/**
 * Configures the Bugsnag client to group and ignore specific errors.
 */
function configureBugsnag() {
  if (global.bugsnagClient == null) {
    return;
  }

  global.bugsnagBeforeSend = report => {
    for (const handler of errorHandlers) {
      const isHandled = handler(report);
      if (isHandled) {
        return;
      }
    }
  };
}

export default configureBugsnag;
